export default __webpack_public_path__ + "static/media/accomm_img_8.6e53592f.JPG";